import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	notFound: {
		margin: '3rem'
	},
	notFoundTitle: {
		marginBottom: '2rem'
	}
});

@withStyles(styles)
class NotFound extends Component {

	render() {
		const { classes } = this.props;
		return (
			<div className={classes.notFound}>
				<Typography className={classes.notFoundTitle} variant="h2">
					{localize('not-found-title')}
				</Typography>
				<Typography variant="body2">
					{localize('not-found-message1')}
				</Typography>
				<Typography variant="body2">
					{localize('not-found-message2')}
				</Typography>
			</div>
		);
	}

}

NotFound.propTypes = {
	classes: PropTypes.object
};


export default NotFound;


// WEBPACK FOOTER //
// ./src/containers/NotFound/NotFound.js